export default __webpack_public_path__ + "static/media/character.04c6488d.jpg";